import type {OverdueChartData, AllocationOverdueData} from "../types/asset-dashboard.type";
import type {AssetsCount, CategoryAssetCount} from "../../../../domains/models/asset-management";


export const getOverdueFromAssetCount = (data: AssetsCount): AllocationOverdueData => {
    const chartData: OverdueChartData[] = data.assetCount.categories
        .filter((item: CategoryAssetCount) => item.overdue > 0)
        .map((item: CategoryAssetCount) => ({
            category: item.name.trim(),
            count: item.overdue,
        }));

    const totalOverdue = data.assetCount.summary.overdue ?? 0;

    return {
        chartData,
        totalOverdue,
    };
};